module.exports = __webpack_public_path__ + "img/bay-pool.80b1f60f.jpg";